import * as React from 'react'
import './styles.scss'

export const SectionContainer = ({ children }: { children: React.ReactNode }) => (
  <div className="section-component">{children}</div>
)
